import 'reflect-metadata'

import Vue from 'vue'
import App from './App.vue'
import '@/scss/index.scss'
import Paginate from 'vuejs-paginate'
import Spinner from '@/components/Spinner.vue'
import Notifications from 'vue-notification'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import router from './router'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

Vue.component('Paginate', Paginate)
Vue.component('Spinner', Spinner)
Vue.use(Notifications)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
